import { ButtonProps } from "@mui/material/Button";
import React, { useMemo } from "react";
import { CountUp } from "../../../components/CountUp";
import { Dialog } from "../../../components/Dialog";
import { Table } from "../../../components/Table";

type DialogDetailClickRateProps = {
  data: any[];
  open: boolean;
  onClose: () => void;
};

export function DialogDetailClickRate({
  data,
  open,
  onClose,
}: DialogDetailClickRateProps) {
  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: onClose,
      },
    ];
  }, [onClose]);

  return (
    <Dialog
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      title="Status dos envios"
      open={open}
      actions={actions}
    >
      <Table
        toolbar={false}
        columnsButton
        pageSize={4}
        columns={[
          { title: "Status", field: "status_envio_externo" },
          {
            title: "Quantidade",
            field: "quantidade",
            render: (row) => (
              <CountUp end={Number(row?.quantidade)} start={0} />
            ),
          },
        ]}
        data={data}
      />
    </Dialog>
  );
}
